import { permissionsRol as analyticsRol } from 'app/policies/roles/analyticsRol.access';
import { PATH_ANALYTIC_AMPLITUDE } from 'app/router/routesConfigAnalyticAmplitude';
import { PATH_ANALYTIC_GAME } from 'app/router/routesConfigAnalyticGame';

export function analytics({ flags, path, user }) {
  if (PATH_ANALYTIC_AMPLITUDE === path) {
    return analyticsRol(user).readList && flags?.showAmplitude;
  }

  if (PATH_ANALYTIC_GAME === path) {
    return analyticsRol(user).readList && flags?.showAnalyticsGame;
  }

  return true;
}
